import { Download, MessageCircle, MapPin } from "lucide-react";
import { PROFILE, UI } from "./profileData";
import { withDefaults, resolveImg } from "@/lib/sections";

export const PortfolioHero = ({ lang, content }) => {
  const t = UI[lang];
  const c = withDefaults("p_hero", content);
  const waLink = `https://wa.me/${PROFILE.whatsapp}?text=${encodeURIComponent(t.waMsg)}`;
  return (
    <section className="section-fade-in flex flex-col-reverse gap-10 pb-12 pt-16 sm:pt-24 lg:flex-row lg:items-center lg:justify-between" data-testid="portfolio-hero">
      <div>
      <p className="font-mono text-sm text-[#FF5500]">{t.hello} {PROFILE.name}</p>
      <h1 className="mt-4 max-w-3xl text-4xl font-semibold leading-tight tracking-tight text-white sm:text-5xl lg:text-6xl">
        Senior Java /<br />
        <span className="text-[#FF5500]">Backend</span> Developer
      </h1>
      <p className="mt-6 max-w-2xl text-sm text-slate-400 sm:text-base" data-testid="hero-intro">{c[`intro_${lang}`]}</p>
      <div className="mt-8 flex flex-wrap items-center gap-3">
        <a
          href={PROFILE.cvUrl}
          download="CV-Isai-Coria.pdf"          className="inline-flex items-center gap-2 rounded-full bg-[#FF5500] px-6 py-3 text-sm font-semibold text-white transition-transform duration-200 hover:-translate-y-0.5 hover:bg-[#ff6a1f]"
          data-testid="download-cv-btn"
        >
          <Download className="h-4 w-4" /> {t.cv}
        </a>
        <a
          href={waLink}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3 text-sm font-semibold text-white transition-colors duration-200 hover:border-emerald-400 hover:text-emerald-300"
          data-testid="whatsapp-contact-btn"
        >
          <MessageCircle className="h-4 w-4" /> {t.wa}
        </a>
        <span
          className="inline-flex items-center gap-2 rounded-full bg-white/5 px-4 py-2 font-mono text-xs text-slate-300"
          data-testid="location-badge"
        >
          <MapPin className="h-3.5 w-3.5 text-[#FF5500]" /> {c[`location_${lang}`]}
        </span>
      </div>
      </div>
      {c.photo && (
        <img src={resolveImg(c.photo)} alt={PROFILE.name} data-testid="portfolio-photo" className="h-40 w-40 shrink-0 rounded-2xl border-2 border-[#FF5500]/60 object-cover shadow-2xl sm:h-56 sm:w-56" />
      )}
    </section>
  );
};

export default PortfolioHero;
